import { verseLines } from "../../lib/lyrics";

/**
 * The lines of one section. With chords on, each chord sits above the words it starts on
 * and follows the transposition; otherwise the words alone. `size` is lg (the live page),
 * sm (song pages) or xs (previews).
 */
const SectionLines = ({ verse, showChords = false, transpose = 0, size = "lg", className = "" }) => {
  const lines = verseLines(verse, transpose);

  return (
    <div className={`lyric-lines lyric-${size} ${className}`.trim()}>
      {lines.map((line, index) =>
        showChords && line.hasChords ? (
          <div key={index} className="lyric-line">
            {line.segments.map((segment, position) => (
              <span key={position} className="seg">
                {segment.chord != null && <span className="lyric-chord">{segment.chord}</span>}
                <span className="lyric-text">{segment.text || " "}</span>
              </span>
            ))}
          </div>
        ) : (
          <div key={index} className="lyric-line">
            <span className="lyric-text">{line.text || " "}</span>
          </div>
        )
      )}
    </div>
  );
};

export default SectionLines;
